// mbscan manager-client へ同じ形で移植する予定（移植までは mbfab のみ）。移植後は片側だけで変えない

import { createContext } from 'react'

import type { JsonObject } from './filter-bar-url-state'

/**
 * useFilterBarState が URL のクエリを読み書きするための口。
 * 汎用 UI からルーティング層（TanStack Router）へ直接依存できない境界のため、アプリ側（components/app の
 * FilterBarUrlProvider）が router につないで供給する。供給が無い場所（story・単体描画）では URL に触れない
 */
export type FilterBarUrlStore = {
  /** 現在の URL のクエリ `key` の値（パース済み）。無ければ undefined */
  read: (key: string) => unknown
  /** クエリ `key` を書き換える。undefined なら消す。履歴は積まず（replace）、他のクエリは保つ */
  write: (key: string, value: JsonObject | undefined) => void
  /** 現在のパス（クエリを含まない）。別の画面へ遷移中かどうかの判定に使う */
  pathname: () => string
  /** マウント中の urlKey として登録する。同じキーが同時に 2 つ登録されたらエラーログ（開発では console.error）を出す。解除関数を返す */
  claimKey: (key: string) => () => void
  /** URL が変わったときに呼ばれる。解除関数を返す */
  subscribe: (onChange: () => void) => () => void
}

export const FilterBarUrlContext = createContext<FilterBarUrlStore | null>(null)
